function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserremove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166.345,
    height: 120,
    viewBox: "0 0 166.345 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lw25nq53ma"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 664",
    transform: "translate(0 -.315)",
    style: {
      fill: "#fff",
      stroke: "#707070"
    },
    d: "M0 0h166.345v120H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17",
    transform: "translate(0 .314)",
    style: {
      clipPath: "url(#lw25nq53ma)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "user (15)",
    transform: "translate(26.997 3.687)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46625",
    d: "M82.886 71.761H3.214a2.208 2.208 0 0 1-2.122-2.829c.669-2.313 1.357-4.607 2.026-6.9a22.539 22.539 0 0 1 3.135-7.3 17.79 17.79 0 0 1 11.259-7.168L31.581 45h22.938l14.069 2.561a17.79 17.79 0 0 1 11.259 7.169 22.539 22.539 0 0 1 3.135 7.3c.669 2.294 1.357 4.588 2.026 6.9a2.208 2.208 0 0 1-2.122 2.829z",
    transform: "translate(0 40.107)",
    style: {
      fill: "#2fa8cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46626",
    d: "M10.352 43.881C5 37.809 5 32.158 5 27.681A27.3 27.3 0 0 1 32.526 1c23.81 0 41.289 11.117 41.289 28.9A23.976 23.976 0 0 1 68.4 43.858z",
    transform: "translate(3.643)",
    style: {
      fill: "#cb8252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46627",
    d: "M63.346 23h1.013a6.57 6.57 0 0 1 4.683 1.969 6.69 6.69 0 0 1-4.683 11.412H12.633A6.69 6.69 0 0 1 7.95 24.969 6.57 6.57 0 0 1 12.633 23z",
    transform: "translate(4.554 20.054)",
    style: {
      fill: "#f9c795"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46628",
    d: "M39.938 50.132s-2.619 5.735-11.469 5.735S17 50.132 17 50.132a7.667 7.667 0 0 0 3.823-6.461v-4.3h15.292v4.3a7.667 7.667 0 0 0 3.823 6.461z",
    transform: "translate(14.581 34.975)",
    style: {
      fill: "#fdd7ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46629",
    d: "M34.292 39.37v4a28.835 28.835 0 0 1-15.292 0v-4z",
    transform: "translate(16.404 34.975)",
    style: {
      fill: "#f9c795"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46630",
    d: "M59.7 29.012v11.66a24.85 24.85 0 1 1-49.7 0V27.237a5.717 5.717 0 0 1 3.1-5.092A24.085 24.085 0 0 0 23.555 12s9.7 9.844 30.882 11.291a5.7 5.7 0 0 1 5.263 5.721z",
    transform: "translate(8.201 10.027)",
    style: {
      fill: "#fdd7ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46631",
    d: "M12.823 55.912v7.646H9v-7.646a1.912 1.912 0 1 1 3.823 0z",
    transform: "translate(7.289 48.311)",
    style: {
      fill: "#2980ba"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 881",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(62.003 61.999)",
    style: {
      fill: "#e64c3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46632",
    d: "M64.761 44H41.823a3.823 3.823 0 1 0 0 7.646h22.938a3.823 3.823 0 0 0 0-7.646z",
    transform: "translate(33.723 39.195)",
    style: {
      fill: "#ecf0f1"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserremove);
export default __webpack_public_path__ + "static/media/userremove.47777bb5bd60e38902a3dc01ea174fab.svg";
export { ForwardRef as ReactComponent };